'use client'
import { faClose, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { memo, useCallback } from 'react'

const SearchInput = ({ IssuerId,issuerSearchInput, setIssuerSearchInput }: {IssuerId: string, issuerSearchInput: string, setIssuerSearchInput: React.Dispatch<React.SetStateAction<string>> }) => {
    const handleIssuerSearchInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setIssuerSearchInput(e.target.value)
    }, [setIssuerSearchInput])

    const handleResetIssuerSearchInput = useCallback(() => {
        setIssuerSearchInput('')
    }, [setIssuerSearchInput])
    return (
        <div className="col-lg-3 position-relative ">
            <input type="text" className="form-control " placeholder={`Search ${IssuerId} Issuers`} value={issuerSearchInput} onChange={handleIssuerSearchInputChange} />
            <FontAwesomeIcon icon={!issuerSearchInput ? faSearch : faClose} size="lg" color='#999' className='ms-2 cursor-pointer position-absolute top-50 translate-middle-y' style={{ right: 20 }} onClick={handleResetIssuerSearchInput} />
        </div>
    )
}

export default memo(SearchInput)